import axios from 'axios'

import { errorTypeService } from './errorTypeService'
import { sessionService } from './sessionService'

export const apiService = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
})

async function handleErrors(error: unknown) {
  if (errorTypeService.isAuthenticationError(error)) {
    await sessionService.logout()
    return
  }
  // Don't handle any other error types
  return Promise.reject(error)
}

apiService.interceptors.response.use(
  // Any status code within the 2xx range will trigger this function
  (response) => response,

  // Any status codes outside the 2xx range will trigger this function
  (error) => handleErrors(error),
)
